export default "__VITE_ASSET__3424ead8__"